module.exports = __webpack_public_path__ + "img/hotdog.1fbe414a.svg";